import { react2angular } from 'react2angular';

import app from '../../../browser/addform/scripts/app';

import { CommercialOwnershipWidget } from './CommercialOwnershipWidget.container';

app.component(
  'commercialOwnershipWidget',
  react2angular(CommercialOwnershipWidget, ['onChange', 'onClear'], ['config', 'httpApi', 'logger']),
);
